import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MinDirectiveModule } from '../minValidator/minDirective.module';
import { MaxDirectiveModule } from '../maxValidator/maxDirective.module';
import { CloneTriggerComponent } from './clone-trigger.component';
import { CloneTriggerService } from './clone-trigger.service';

@NgModule({
    imports: [AppMaterialModule, FormsModule, CommonModule, ReactiveFormsModule, MinDirectiveModule, MaxDirectiveModule],
    exports: [CloneTriggerComponent],
    declarations: [CloneTriggerComponent],
    providers: [CloneTriggerService]
})
export class CloneTriggerModule {}
